export default __webpack_public_path__ + "static/vscodehello-e3e8051f4a7e75f0c0f962a9088f9cce.png";